import { useEffect, useRef } from "react";
import { useSignal, signal } from "@preact/signals-react";

import ModalForm from "componentsv2/modal/ModalForm";
import SearchBar from "componentsv2/widgets/SearchBar";
import GridCards from "componentsv2/card/GridCardsNew";
import OptionsFilter from "./components/OptionsFilter";
import MenuReports from "componentsv2/menu/MenuReports";
import TableTitle from "componentsv2/table/TableTitle";
import { genStoreId } from "componentsv2/tools/functions";
import { useStore, insertRecord } from "storev2/formStore";
import WizardScheduleEmployee from "./components/WizardScheduleEmployee";
import Dropdown from "componentsv2/form/Dropdown";

const employeeData = signal(null);

const searchEmployee = (value) => {
  if (!value) return [];
  return [["party.name", "ilike", `%${value}%`]];
};

function CardsRooms({ layout, parentRec, records, onRefresh }) {
  const openModal = useSignal(false);
  const recStoreId = useSignal(null);
  const refreshKey = useSignal(0);
  const filters = useSignal(new Map());
  const filteredRecords = useSignal(records);
  const { reload: reloadForm } = useStore();

  const prevRecords = useRef(records);

  useEffect(() => {
    if (employeeData.value?.id) {
      filteredRecords.value = (records || []).filter(
        (rec) => rec.housekeeping === employeeData.value.rec_name,
      );
    } else {
      filteredRecords.value = records;
    }
  }, [employeeData.value, records]);

  useEffect(() => {
    if (filters.value.size === 0 && prevRecords.current !== records) {
      filteredRecords.value = records;
    }
    prevRecords.current = records;
  }, [records, filters, filteredRecords]);

  const { model, Card } = layout;
  const storeId = genStoreId(model, null, parentRec);

  async function closeModal() {
    openModal.value = false;
    if (parentRec?.storeId) await reloadForm(parentRec.storeId);
    if (onRefresh) await onRefresh();
    refreshKey.value++;
  }

  async function handleView(action, recordId) {
    if (action === "open") {
      recStoreId.value = await insertRecord(recordId, model, layout);
    } else {
      recStoreId.value = await newRecord(layout, parentRec);
    }
    openModal.value = true;
  }

  async function handleFilter(nameField, listValues) {
    if (listValues.length === 0) {
      filters.value.delete(nameField);
      filteredRecords.value = records;
      return;
    }

    filters.value.set(nameField, listValues);
    const recordsTarget = [];
    records.forEach((rec) => {
      for (const [field, values] of filters.value.entries()) {
        if (rec[field].includes(values) || values.includes(rec[field])) {
          recordsTarget.push(rec);
        }
      }
    });
    filteredRecords.value = recordsTarget;
  }

  return (
    <div id="board-cards" className="mt-4 mb-6 px-3">
      <div className="flex gap-x-3">
        <TableTitle layout={layout} />
        <div className="md:flex w-full ml-auto md:w-fit gap-x-2 justify-end">
          <div className="min-w-75 flex items-center gap-x-5">
            <SearchBar
              name="search-widget"
              handleSearch={(textWords) => handleFilter("name", textWords)}
              size="w-full"
            />
            <Dropdown
              name="employee"
              placeholder="Nombre empleado..."
              model="company.employee"
              data={employeeData}
              field={{ model: "company.employee" }}
              recSearch={searchEmployee}
            />
          </div>
          <MenuReports reports={layout.toolbar_table.reports} />
        </div>
        <WizardScheduleEmployee />
      </div>

      <div className="px-2 flex items-center overflow-x-auto mb-4">
        <div className="flex items-center mt-4">
          <OptionsFilter
            name="state"
            handleFilter={handleFilter}
            model={layout.model}
            options={layout.tags.state}
          />
          <div className="h-8 border-r border-slate-300 mx-4 shrink-0" />
          <OptionsFilter
            name="occ_state"
            handleFilter={handleFilter}
            model={layout.model}
            options={layout.tags.occ_state}
          />
        </div>
      </div>
      <div className="min-h-50">
        {!records ? (
          <div className="text-center py-20 text-neutral-400 font-medium">
            Loading...
          </div>
        ) : (
          <GridCards
            key={refreshKey.value}
            storeId={storeId}
            records={filteredRecords.value}
            Card={Card}
            handleView={handleView}
            layout={layout}
          />
        )}
      </div>
      <div className="board-cards-modal">
        {openModal.value && recStoreId.value && (
          <ModalForm
            storeId={recStoreId.value}
            layout={layout}
            parentRec={parentRec}
            onClose={closeModal}
            size="h-5/6 w-full md:w-1/2"
            openModal={openModal}
          />
        )}
      </div>
    </div>
  );
}

// {!records ? (
//   <div className="text-center py-20 text-neutral-400 font-medium">
//     Loading...
//   </div>
// ) : records.value?.length > 0 ? (

// ) : (
//   <div className="text-center py-20 text-neutral-400 font-medium">
//     No hay habitaciones
//   </div>
// )
// }

export default CardsRooms;
